<script setup lang="ts">
const { params, myOrders, isLoading, status, error } = useMyOrders();
const columns: TableColumn<Order>[] = [
  { key: "order_id", label: "# commande", width: "128px", verticalAlign: "middle" },
  { key: "timestamp", label: "Date", mobileFullWidth: true, verticalAlign: "middle" },
  { key: "status", label: "État", mobileFullWidth: true, verticalAlign: "middle" },
  { key: "total", label: "Total", mobileFullWidth: true, verticalAlign: "middle" },
  { key: "links", label: "", horizontalAlign: "right" },
];
async function onUpdatePage() {
  await nextTick();
  document.getElementById("my-orders")?.scrollIntoView({ behavior: "smooth" });
}
</script>

<template>
  <UiDefaultPage id="my-orders" title="Commandes">
    <div class="space-y-8">
      <UiQueryWrapper :is-loading="isLoading" :status="status" :error="error">
        <UiEmptyResult v-if="!myOrders.orders.length" title="Aucune commande" />
        <UiResponsiveTable v-else :columns="columns" :data="myOrders.orders">
          <template #order_id-cell="{ row }">
            <OrderLink :order-id="row.order_id" />
          </template>"
          <template #timestamp-cell="{ row }">
            {{ date(row.timestamp) }}
          </template>
          <template #total-cell="{ row }">
            <div class="flex flex-col">
              <div class="inline-flex items-center gap-1 text-lg font-semibold text-primary">
                <span :class="{ 'text-muted line-through': row.total_refunded !== undefined }">{{ currency(row.total_order) }}</span>
                <span v-if="row.total_refunded !== undefined" class="">{{ currency(row.total_refunded) }}</span>
              </div>
              <div class="text-sm text-muted">
                Pour {{ pluralize(row.item_count, "item", "items") }}
              </div>
            </div>
          </template>
          <template #links-cell="{ row }">
            <div class="flex flex-wrap items-center gap-2">
              <UiLink v-for="(link, i) in row.links" :key="i" :link="link" />
            </div>
          </template>
        </UiResponsiveTable>
      </UiQueryWrapper>
      <UiPagination v-model:page="params.page" :items-per-page="params.per_page" :total="myOrders.orders_total" @update:page="onUpdatePage" />
    </div>
  </UiDefaultPage>
</template>
